/**
 * Sourced from https://ui.shadcn.com
 * See docs/shadcn-registry.md for more
 */

import { cn } from '@/lib/utils'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
    return (
        <div
            data-slot="skeleton"
            className={cn('animate-pulse rounded-md bg-accent', className)}
            {...props}
        />
    )
}

export { Skeleton }
